import {plural} from "@Common/ui-components/language/plural";

export const maxLength = (length)=> ({
    name: "maxLength",
    validate: (value) => value == null || value.length <= length,
    getMessage: (value) => `Exceeded ${value.length - length} ${plural("character", value.length - length)}`,
});
